// src/pages/produtos/produtos/DeliveryTab.js
import React, { useState } from 'react';
import Input from '../../../components/input/Input';
import InputCheck from '../../../components/input/InputCheck';
import DestaqueProdutoSearch from '../destaqueProdutos/DestaqueProdutoSearch';
import DestaqueProdutoCad from '../destaqueProdutos/DestaqueProdutoCad';
import { useDestaqueProduto } from '../../../contexts/produtos/DestaqueProdutoContext';
import { DestaqueProduto } from '../../../models/produtos/DestaqueProduto';
import { MdOutlineUnfoldMore } from 'react-icons/md';
import ModalOrdemProduto from './ModalOrdemProduto';
import ProdutoImagemModal from './ProdutoImagemModal';
import './DeliveryTab.css';

const DeliveryTab = ({
    produto,
    setProduto,
    disableCampos,
}) => {
    const { destaqueProdutos } = useDestaqueProduto();
    const [showSearchDestaqueProduto, setShowSearchDestaqueProduto] = useState(false);
    const [showCadDestaqueProduto, setShowCadDestaqueProduto] = useState(false);
    const [showModalOrdemProduto, setShowModalOrdemProduto] = useState(false);
    const [showProdutoImagemModal, setShowProdutoImagemModal] = useState(false);

    const handleExitDestaqueProduto = (destaqueProdutoId) => {
        const destaqueProdutoSelecionado = destaqueProdutos.find(
            (item) => item.id.toString() === destaqueProdutoId.toString(),
        );

        if (destaqueProdutoSelecionado) {
            setProduto({
                ...produto,
                destaqueProdutoId: destaqueProdutoSelecionado.id,
                destaqueProduto: destaqueProdutoSelecionado,
            });
        } else {
            setProduto({
                ...produto,
                destaqueProdutoId: null,
                destaqueProduto: new DestaqueProduto(),
            });
        }
    };

    const handleSelectDestaqueProduto = (destaqueProduto) => {
        setProduto({
            ...produto,
            destaqueProdutoId: destaqueProduto?.id || null,
            destaqueProduto: destaqueProduto || new DestaqueProduto(),
        });
        setShowSearchDestaqueProduto(false);
    };

    return (
        <div className="produto-delivery-tab">
            <div className="input-group">
                <InputCheck
                    label="Venda no App"
                    checked={produto.vendeApp}
                    onChange={(e) => setProduto({ ...produto, vendeApp: e.target.checked })}
                />
                <InputCheck
                    label="Seleciona Ponto"
                    checked={produto.selPonto}
                    onChange={(e) => setProduto({ ...produto, selPonto: e.target.checked })}
                />
                <InputCheck
                    label="Gera Ticket"
                    checked={produto.geraTicket}
                    onChange={(e) => setProduto({ ...produto, geraTicket: e.target.checked })}
                />
                <InputCheck
                    label="Usar Rolagem"
                    checked={produto.usarRolagem}
                    onChange={(e) => setProduto({ ...produto, usarRolagem: e.target.checked })}
                />
                <div className="form-group" style={{ display: !produto.geraTicket && 'none' }}>
                    <label className="form-label">Descricao do Ticket</label>
                    <textarea
                        value={produto.descTicket}
                        onChange={(e) => setProduto({ ...produto, descTicket: e.target.value })}
                        rows={2}
                        className="form-control"
                    />
                </div>
            </div>

            <div className="input-group">
                <Input
                    label="Destaque Produto"
                    value={produto.destaqueProduto?.id || produto.destaqueProdutoId || ''}
                    onChange={(e) => setProduto({
                        ...produto,
                        destaqueProdutoId: e.target.value,
                        destaqueProduto: {
                            ...produto.destaqueProduto,
                            id: e.target.value,
                        },
                    })}
                    onBlur={(e) => handleExitDestaqueProduto(e.target.value)}
                    disabled={disableCampos}
                    btnBuscarDisabled={disableCampos}
                    btnAddDisabled={disableCampos}
                    btnBuscar={() => setShowSearchDestaqueProduto(true)}
                    btnAdd={() => setShowCadDestaqueProduto(true)}
                    size={80}
                />
                <Input
                    value={produto.destaqueProduto?.titulo || ''}
                    size={300}
                    disabled
                />
            </div>
            <div className="input-group">
                <Input
                    label="Cashback %"
                    value={produto.cashBackPercent || ''}
                    onChange={(e) => setProduto({ ...produto, cashBackPercent: e.target.value })}
                    type="number"
                    size={110}
                    disabled={disableCampos}
                />
                <InputCheck
                    label="Imprimir Ingredientes"
                    checked={produto.imprimirIngredientes}
                    onChange={(e) => setProduto({ ...produto, imprimirIngredientes: e.target.checked })}
                    disabled={disableCampos}
                />
            </div>
            <div className="input-group">
                <div className="form-group">
                    <label className="form-label">Ingredientes</label>
                    <textarea
                        style={{ width: '450px' }}
                        value={produto.ingredientes}
                        onChange={(e) => setProduto({ ...produto, ingredientes: e.target.value })}
                        rows={3}
                        className="form-control"
                    />
                </div>                
            </div>

            <div className="input-group">
                <div>
                    <label className="form-label">Imagem</label>
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => setShowProdutoImagemModal(true)}
                        disabled={disableCampos}
                    >
                        {produto.imagemId || produto.imagem ? 'Editar imagem' : 'Adicionar imagem'}
                    </button>
                </div>                
                <div>
                    <label className="form-label">Ordem Exibição</label>
                    <button
                        type="button"
                        className="btn btn-outline-primary justify-content-center"
                        onClick={() => setShowModalOrdemProduto(true)}
                        disabled={disableCampos || !produto?.grupo?.id}                        
                    >
                        Ordenar <MdOutlineUnfoldMore />
                    </button>
                </div>

                
            </div>
            <DestaqueProdutoSearch
                show={showSearchDestaqueProduto}
                onHide={() => setShowSearchDestaqueProduto(false)}
                onSelectDestaqueProduto={handleSelectDestaqueProduto}
            />
            <DestaqueProdutoCad
                show={showCadDestaqueProduto}
                onHide={() => setShowCadDestaqueProduto(false)}
            />
            <ModalOrdemProduto
                show={showModalOrdemProduto}
                onHide={() => setShowModalOrdemProduto(false)}
                produtoSelecionado={produto}
                onProdutoAtualizado={(produtoAtualizado) => setProduto((prev) => ({
                    ...prev,
                    orderNum: produtoAtualizado.orderNum,
                }))}
            />
            <ProdutoImagemModal
                show={showProdutoImagemModal}
                onHide={() => setShowProdutoImagemModal(false)}
                produto={produto}
                setProduto={setProduto}
            />
        </div>
    );
};

export default DeliveryTab;
